module.exports = __webpack_public_path__ + "img/ignis.833fc59d.png";